import type { SimState } from '../sim/types';

export const CURRENT_SCHEMA_VERSION = 1;

export type SlotId = 'autosave' | 'manual';

export interface SaveEnvelope {
  schemaVersion: number;
  savedAt: string; // ISO 8601 string
  state: SimState;
}

export interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

export type Clock = () => string;

export type SaveResult =
  | { ok: true; savedAt: string }
  | { ok: false; reason: 'STORAGE_UNAVAILABLE' | 'QUOTA_EXCEEDED' | 'SERIALIZE_FAILED' };

export type LoadFailReason =
  | 'NO_SAVE'
  | 'STORAGE_UNAVAILABLE'
  | 'CORRUPT_JSON'
  | 'INVALID_ENVELOPE'
  | 'NEWER_VERSION'
  | 'MIGRATION_FAILED'
  | 'INVALID_STATE'
  | 'UNKNOWN_CONTENT_ID';

export type LoadResult =
  | { ok: true; state: SimState; savedAt: string }
  | { ok: false; reason: LoadFailReason; message?: string };

